import { render, staticRenderFns } from "./DepositTabNav.vue?vue&type=template&id=057f6694"
import script from "./DepositTabNav.vue?vue&type=script&lang=js"
export * from "./DepositTabNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports